<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '供应商商品'"
    v-model="modal" width="800">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="100">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="商品名称:" prop="supplierCommodityName">
            <Input v-model="handleForm.supplierCommodityName" maxlength="30" show-word-limit></Input>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="商品类型:">
            <Select v-model="handleForm.couponType" @on-change="changeType">
              <Option :value="1">单券</Option>
              <Option :value="2">券包</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24" v-if="handleForm.couponType === 2">
          <FormItem
            v-for="(item, index) in formDynamic.items"
            v-if="item.status"
            :key="index"
            :label="'券 ' + item.index"
            :rules="{required: true, message: 'Item ' + item.index +' can not be empty', trigger: 'blur'}">
            <Row>
              <Col span="8">
                <Select v-model="item.supplierId" style="width:200px" @on-change="loadCouponData" filterable>
                  <Option v-for="item1 in suppliers" :value="item1.id" :key="item1.id">{{ item1.name }}</Option>
                </Select>
              </Col>
              <Col span="16" style="display: flex">
                <Select v-model="item.couponId" style="width:350px" filterable :disabled="item.supplierId === ''">
                  <Option v-for="item1 in couponList[item.supplierId]" :value="item1.id" :key="item1.id">{{ item1.supplierCommodityName }}</Option>
                </Select>
                <Button @click="handleRemove(index)" type="text"><Icon type="md-trash" size="20" v-show="formDynamic.items.length > 1" /></Button>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="12">
                <Button type="dashed" long @click="handleAdd" icon="md-add">Add item</Button>
              </Col>
            </Row>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24" v-if="handleForm.couponType === 1">
          <FormItem label="商品标识:" prop="supplierCommodityNo">
            <Input v-model="handleForm.supplierCommodityNo" show-word-limit></Input>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="销售价:" prop="costPrice">
            <InputNumber
              style="width: 100%;"
              :min="0"
              v-model="handleForm.costPrice"
              :formatter="value => `${value}元`"
              :parser="value => value.replace('元', '')" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="销售折扣:" prop="costDiscount">
            <InputNumber
              style="width: 100%;"
              :max="100"
              :min="0"
              v-model="handleForm.costDiscount"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="税点:" prop="taxPoint">
            <InputNumber
              style="width: 100%;"
              :max="20"
              :min="0"
              v-model="handleForm.taxPoint"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="对账规则:" prop="reconciliationRules">
            <Select
              v-model="handleForm.reconciliationRules"
              style="width: 100%;"
              filterable>
                <Option v-for="item in reconciliationRulesList" :value="item.code" :key="item.code">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'
export default {
  name: 'SupplierCommodityCreateUpdate',
  props: {
    defaultSupplierId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      couponList: {},
      suppliers: [],
      index: 1,
      formDynamic: {
        items: [
          {
            value: '',
            index: 1,
            status: 1,
            supplierId: this.defaultSupplierId,
            couponId: ''
          }
        ]
      },
      modal: false,
      loading: false,
      action: 'create',
      handleForm: {
        couponType: 1,
        supplierId: null,
        supplierCommodityName: null,
        supplierCommodityNo: null,
        costPrice: 0,
        costDiscount: 0,
        taxPoint: 0,
        useState: 1,
        reconciliationRules: 0,
        // 供应商商品默认数据
        sourceType: 1,
        labelId: 0
      },
      reconciliationRulesList: [
        { code: 0, label: '订购即对账' },
        { code: 1, label: '核销后对账' }
      ],
      handleValidate: {
        supplierCommodityName: [
          { required: true, whitespace: true, message: '请输入供应商商品名称', trigger: 'blur' }
        ],
        supplierCommodityNo: [
          { required: true, whitespace: true, message: '请输入商品标识', trigger: 'blur' }
        ],
        costPrice: [
          { required: true, whitespace: true, type: 'number', message: '请输入销售价', trigger: 'blur' }
        ],
        costDiscount: [
          { required: true, whitespace: true, type: 'number', message: '请输入销售折扣', trigger: 'blur' }
        ],
        taxPoint: [
          { required: true, whitespace: true, type: 'number', message: '请输入税点', trigger: 'blur' }
        ],
        reconciliationRules: [
          { required: true, whitespace: true, type: 'number', message: '请选择对账方式', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    }
  },
  mounted() {
    this.getSuppliers()
  },
  methods: {
    changeType(i) {
      if (i === 2) {
        this.loadCouponData()
      }
      this.index = 1
      this.supplierCommodityNo = ''
      this.formDynamic = {
        items: [
          {
            value: '',
            index: 1,
            status: 1,
            supplierId: this.defaultSupplierId || '',
            couponId: ''
          }
        ]
      }
    },
    getSuppliers() {
      api.supplier.supplierList({
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        this.suppliers = res.data.records || []
      }).catch(err => {
        this.$Message.error(err.message || '获取供应商列表失败，请刷新重试！')
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleAdd () {
      this.index++;
      this.formDynamic.items.push({
        value: '',
        index: this.index,
        status: 1,
        supplierId: this.defaultSupplierId,
        couponId: ''
      });
      console.log('this.formDynamic.items', this.formDynamic.items)
    },
    handleRemove (index) {
      if (this.formDynamic.items.length <= 1) {
        return
      }
      this.formDynamic.items.splice(index, 1)
    },
    loadCouponData(supplierId = this.defaultSupplierId) {
      this.loading = true
      api.commodity.commodityList({
        supplierId,
        sourceType: 1,
        useState: 1,
        pageNum: 1,
        pageSize: 999
      })
        .then((res) => {
          this.loading = false
          this.$set(this.couponList, supplierId, res.data.records || [])
          // this.couponList[supplierId] = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取供应商列表失败: ' + err.message)
        })
    },
    show (action = 'create', data = {}, index) {
      if (data.couponType === 2) {
        api.order.queryCommodityItems({id: data.id}).then(res => {
          let items = []
          for (let i = 0; i < res.data.length; i++) {
            items.push({
              value: res.data[i].id,
              index: i+1,
              status: 1,
              supplierId: res.data[i].supplierId,
              couponId: res.data[i].id
            })
            this.loadCouponData(res.data[i].supplierId)
          }
          this.formDynamic.items = items
        })
      }
      // console.log('供应商商品编辑传入', data)
      this.action = action
      this.handleForm.supplierId = this.action === 'update' ? data.supplierId : data.id
      if (this.action === 'update') {
        this.handleForm = {
          ...this.handleForm,
          commodityId: data.id,
          // supplierCommodityName: data.commodityName,
          supplierCommodityName: data.supplierCommodityName,
          supplierCommodityNo: data.supplierCommodityNo,
          costPrice: data.costPrice,
          couponType: data.couponType,
          costDiscount: data.costDiscount,
          taxPoint: data.taxPoint,
          useState: data.useState,
          reconciliationRules: data.reconciliationRules
        }
      }
      this.modal = true
    },
    hide () {
      // this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false

      this.handleForm = {
        couponType: 1,
        supplierId: null,
        supplierCommodityName: null,
        supplierCommodityNo: null,
        costPrice: 0,
        costDiscount: 0,
        taxPoint: 0,
        useState: 1,
        reconciliationRules: 0,
        // 供应商商品默认数据
        sourceType: 1,
        labelId: 0
      }
      this.formDynamic = {
        items: [
          {
            value: '',
            index: 1,
            status: 1,
            supplierId: this.defaultSupplierId,
            couponId: ''
          }
        ]
      }
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let couponList = []
      if (this.handleForm.couponType === 2) {
        for (let i = 0; i < this.formDynamic.items.length; i++) {
          let item = this.formDynamic.items[i]
          if (!item.couponId || !item.supplierId) {
            this.$Message.error(`请选择[券${i+1}]供应商商品`)
            return
          }
          couponList.push({
            itemSort: i,
            supplierId: item.supplierId,
            commodityId: item.couponId
          })
        }
      }
      let queryParams = {
        ...this.handleForm,
        couponList
      }
      let submitApi = api.commodity.commodityCreateUpdate
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
        this.queryCommodity = ''
      }).catch(err => {
        this.$Message.error({
          content: this.actionText + '失败：' + err,
          duration: 2
        })
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
